<template>
  <BModal
    id="modal-tall"
    :model-value="modal"
    scrollable
    centered
    title="Reservation Information"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Reservation Information</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <template #body>
      <BRow>
        <BCol>
          <div class="form-group">
            <label for="">Check-in Date</label>
            <p>{{ reservationData }}</p>
          </div>
        </BCol>
      </BRow>
    </template>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="payBill()"
          class="mr-2"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Pay" }}</BButton
        >
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { inject, ref } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import { formatIDR } from "@/utils/currency";

import {
  BRow,
  BCol,
  //   BForm,
  BModal,
  //   BTabs,
  //   BTab,
  //   BFormInput,
  //   BFormSelect,
  //   BFormSelectOption,
  // BInputGroup,
  BButton,
  // BListGroup,
  // BListGroupItem,
  //   BFormTextarea,
  // BFormRadioGroup,
} from "bootstrap-vue-next";
export default {
  props: {
    modal: Boolean,
    reservationData: Object,
  },
  name: "CheckInForm",
  components: {
    BRow,
    BCol,
    // BForm,
    // BTabs,
    // BTab,
    BModal,
    // BFormInput,
    // BFormSelect,
    // BFormSelectOption,
    //   BInputGroup,
    BButton,
    // BListGroup,
    // BListGroupItem,
    // BFormTextarea,
    // BFormRadioGroup,
    ToastResponse,
  },

  emits: ["update:modal"],

  setup(props, { emit }) {
    console.log("dari rese in", props.reservationData);

    const repositories = inject("repositories");
    const billRepository = repositories ? repositories.reservations : null;
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const isLoading = ref(false);

    const options = ref([
      {
        text: "Ya",
      },
      {
        text: "Tidak",
      },
    ]);

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const selectedPaymentMethod = ref(null);
    const paymentMethods = ref([]);

    const paymentForm = ref({
      reservation_uuid: props.uuid,
      payment_method_uuid: null,
      payment_type: "Payment",
      payment_date: null,
      amount: null,
      reference_number: null,
    });

    const bill = ref({
      reservation: {},
      guest: {},
      grand_total: 0,
      total_paid: 0,
      sisa_tagihan: 0,
      is_paid: false,
      room: [{}],
      payments: [{}],
      extra_charges: [{}],
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const getBill = async (uuid) => {
      try {
        const response = await billRepository.getBill(uuid);
        bill.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const resetForm = () => {
      paymentForm.value = {
        reservation_uuid: props.uuid,
        payment_method_uuid: null,
        payment_type: "Payment",
        payment_date: null,
        amount: null,
        reference_number: null,
      };
    };

    const payBill = async () => {
      try {
        isLoading.value = true;
        const response = await billRepository.payBill(paymentForm.value);
        modalResponse.value = {
          toast: true,
          text: response.data.message,
          success: true,
        };
        emit("paid");
        updateModal(false);
        resetForm();
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        modalResponse.value = {
          toast: true,
          text: error.response.data.message,
          success: false,
        };
      }
    };

    const getListPaymentMethod = () => {
      paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = [
            ...res.data.data.filter((i) => (i.status === "active" ? i : null)),
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    return {
      bill,
      getBill,
      payBill,
      getListPaymentMethod,
      billRepository,
      paymentMethodRepository,
      paymentForm,
      updateModal,
      modalResponse,
      isLoading,
      paymentMethods,
      selectedPaymentMethod,
      options,
      formatIDR,
    };
  },
};
</script>

<style></style>
